import { Button } from '@/components/ui/button';
import { ArrowRight, GitBranch } from 'lucide-react';

interface PlanApprovalCardProps {
  stepCount: number;
  workflowName?: string | null;
  onStartBuilding: () => void;
}

export function PlanApprovalCard({ stepCount, workflowName, onStartBuilding }: PlanApprovalCardProps) {
  return (
    <div className="rounded-xl border border-primary/30 bg-primary/5 p-4 space-y-3">
      <div className="flex items-start gap-3">
        <div className="h-8 w-8 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
          <GitBranch className="h-4 w-4 text-primary" />
        </div>
        <div className="space-y-1 min-w-0">
          <p className="text-sm font-medium">
            {workflowName ? `Plan for "${workflowName}" is ready.` : 'Plan is ready.'}
          </p>
          <p className="text-xs text-muted-foreground">
            Review the {stepCount} {stepCount === 1 ? 'step' : 'steps'} on the canvas. When you're ready, I'll start drafting the prompt for step I.
            Or keep chatting to adjust the plan first.
          </p>
        </div>
      </div>
      <div className="flex justify-end">
        <Button size="sm" onClick={onStartBuilding} className="gap-1.5 text-xs">
          Start building
          <ArrowRight className="h-3.5 w-3.5" />
        </Button>
      </div>
    </div>
  );
}
